"use client";
import { useTranslations } from "next-intl";
import { CustomTooltip } from "@/app/components/ui";
import { PanelLeftOpen, PanelRightOpen } from "lucide-react";

interface ChatHistorySidebarToggleProps {
   isOpen: boolean;
   onOpenChange: (open: boolean) => void;
   sidebarWidth: number;
   isResizing: boolean;
   className?: string;
}

export const ChatHistorySidebarToggle: React.FC<ChatHistorySidebarToggleProps> = (
   props: ChatHistorySidebarToggleProps
) => {
   const translate = useTranslations("Home");
   const { isOpen, onOpenChange, sidebarWidth, isResizing } = props;

   return (
      <CustomTooltip
         text={translate(isOpen ? "closeChatHistory" : "openChatHistory")}
         delayDuration={200}
      >
         <div
            onClick={() => onOpenChange(!isOpen)}
            className={`fixed ${
               isOpen ? "-left-5" : "-left-4 hover:left-0"
            } top-[110px] z-50 ${
               isResizing ? "" : "duration-300"
            } transform rounded-full w-[42px] h-[42px] flex items-center justify-center cursor-pointer bg-background border border-transparent hover:border-border
             shadow-md hover:bg-gray-100 hover:dark:bg-gray-900 `}
            style={{
               transform: isOpen
                  ? `translate(${sidebarWidth}px, -50%)`
                  : "translate(0, -50%)"
            }}
         >
            {isOpen ? (
               <PanelRightOpen size={25} strokeWidth={0.6} />
            ) : (
               <PanelLeftOpen size={25} strokeWidth={0.6} />
            )}
         </div>
      </CustomTooltip>
   );
};
